import React from 'react';
import { Search, Calendar, Filter } from 'lucide-react';

const EvaluationFilters = ({
  filters,
  setFilters,
  classes,
  modules,
  selectedClasse,
  setSelectedClasse,
  selectedModule,
  setSelectedModule,
  loadModulesByClasse
}) => {

  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleClasseChange = (classeId) => {
    setSelectedClasse(classeId);
    handleFilterChange('classe', classeId);
    loadModulesByClasse(classeId);
    setSelectedModule('');
    handleFilterChange('module', '');
  };

  const handleModuleChange = (moduleId) => {
    setSelectedModule(moduleId);
    handleFilterChange('module', moduleId);
  };



  const clearFilters = () => {
    setFilters({
      libelle: '',
      date_debut: '',
      date_fin: '',
      classe: '',
      module: '',
      status_note: ''
    });
    setSelectedClasse('');
    setSelectedModule('');
  };

  return (
    <div className="bg-gray-50 border-b border-gray-200 p-4">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Recherche par libellé */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Rechercher
          </label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input
              type="text"
              placeholder="Devoir, Interrogation..."
              value={filters.libelle}
              onChange={(e) => handleFilterChange('libelle', e.target.value)}
              className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#202654] focus:border-transparent"
            />
          </div>
        </div>

        {/* Classe */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Classe
          </label>
          <select
            value={selectedClasse}
            onChange={(e) => handleClasseChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#202654] focus:border-transparent"
          >
            <option value="">Toutes les classes</option>
            {classes.map(classe => (
              <option key={classe.id} value={classe.id}>
                {classe.libelle}
              </option>
            ))}
          </select>
        </div>

        {/* Module */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Module
          </label>
          <select
            value={selectedModule}
            onChange={(e) => handleModuleChange(e.target.value)}
            disabled={!selectedClasse}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#202654] focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
          >
            <option value="">Tous les modules</option>
            {modules.map(module => (
              <option key={module.id} value={module.id}>
                {module.libelle || module.module?.libelle || 'Module sans nom'}
              </option>
            ))}
          </select>
        </div>

        {/* Statut des notes */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Statut
          </label>
          <select
            value={filters.status_note}
            onChange={(e) => handleFilterChange('status_note', e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#202654] focus:border-transparent"
          >
            <option value="">Tous les statuts</option>
            <option value="true">Noté</option>
            <option value="false">En attente</option>
          </select>
        </div>

        {/* Date début */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date début
          </label>
          <div className="relative">
            <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input
              type="date"
              value={filters.date_debut}
              onChange={(e) => handleFilterChange('date_debut', e.target.value)}
              className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#202654] focus:border-transparent"
            />
          </div>
        </div>

        {/* Date fin */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Date fin
          </label>
          <div className="relative">
            <Calendar className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input
              type="date"
              value={filters.date_fin}
              onChange={(e) => handleFilterChange('date_fin', e.target.value)}
              className="pl-10 w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#202654] focus:border-transparent"
            />
          </div>
        </div>
      </div>

      {/* Bouton pour réinitialiser les filtres */}
      <div className="flex justify-end mt-4">
        <button
          onClick={clearFilters}
          className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          <Filter className="h-4 w-4 mr-2" />
          Réinitialiser
        </button>
      </div>
    </div>
  );
};

export default EvaluationFilters; 